module.exports = {
      id: "gallery-usage",
      viewBox: "0 0 61 48",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#gallery",
      toString: function () {
        return this.url;
      }
    }